import {
  SUBMIT_CHECKOUT_FAILURE,
  SUBMIT_CHECKOUT_SUCCESS,
  ADD_APPOINTMENT_DATA_FAILURE,
  ADD_APPOINTMENT_DATA_SUCCESS,
  UPLOAD_TECHNICAL_CARD_PICTURE_ERROR,
} from './types';

const INITIAL_STATE = {
  error: null,
  data: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SUBMIT_CHECKOUT_FAILURE: {
      return {
        ...state,
        error: action.payload.error
      };
    }
    case SUBMIT_CHECKOUT_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case ADD_APPOINTMENT_DATA_FAILURE:
    case UPLOAD_TECHNICAL_CARD_PICTURE_ERROR:
      return {
        ...state,
        error: action.payload.error
      };
    case ADD_APPOINTMENT_DATA_SUCCESS:
      return {
        ...state,
        ...action.payload
      }
    default:
      return {
        ...state
      };
  }
}


// WEBPACK FOOTER //
// ./src/workflow/checkout/clientRegistration/reducer.js